
import { Component, Prop, Vue } from 'vue-property-decorator';
import api from '@/api';
import moment from 'moment';
import { Route } from 'vue-router';
import Swal from 'sweetalert2';
import adBlockType from '@/enums/adBlockType';
import ItemForm from './Form.vue';

const { appAd } = api;

@Component({
  components: { ItemForm },
})
export default class AppAdvertisementEdit extends Vue {
  @Prop({}) private id!: string;

  private blockType: adBlockType = adBlockType.None;

  private get getTitle() {
    return this.blockType === adBlockType.Popup ? '編輯首頁彈窗廣告' : '編輯首頁廣告版位';
  }

  private form = {
    title: null,
    openLinkMethod: null,
    startTime: null,
    endTime: null,
    ImageUrl: null,
    url: null,
    priority: null,
  };

  private loading: boolean = false;

  private async submit(form: any) {
    if (form) {
      this.loading = true;
      const { status } = await appAd.update(this.id, form, this.blockType);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '修改成功' });
        await this.$router.back();
      }
    }
  }

  private setForm(data: any) {
    this.form = data;
  }

  private setBlockType(type: any) {
    this.blockType = type;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: AppAdvertisementEdit) => void) => void,
  ) {
    const blockType = to.name === 'appAdPopupEdit' ? adBlockType.Popup : adBlockType.Carousel;
    const { id } = to.params;
    const { data } = await appAd.get(id, blockType);
    data.startTime = moment(data.startTime).format('YYYY-MM-DD HH:mm');
    data.endTime = moment(data.endTime).format('YYYY-MM-DD HH:mm');
    await next(async (vm) => {
      vm.setBlockType(blockType);
      vm.setForm(data);
    });
  }
}
